import type { StateTagWrapperProps } from "./state-tag.type";

import { REFERENTIAl_STATES_ENDPOINT } from "@/entities/referential/referential-states";

import { StateTag } from "./state-tag.component";

export const StateTagWrapper = ({
  type,
  value,
  asText,
}: StateTagWrapperProps) => {
  /**
   * Type of {type} should be a value of REFERENTIAl_STATES_ENDPOINT directly
   * but we need to migrate to TS all files that use <StateTag /> component before.
   * Meanwhile, we force the cast of the type.toUpperCase() to a key of REFERENTIAl_STATES_ENDPOINT.
   * */
  const key = type.toUpperCase() as keyof typeof REFERENTIAl_STATES_ENDPOINT;
  const endpoint =
    key in REFERENTIAl_STATES_ENDPOINT
      ? REFERENTIAl_STATES_ENDPOINT[key]
      : undefined;

  if (!endpoint) return null;

  return <StateTag endpoint={endpoint} value={value} asText={asText} />;
};
